import { ThreeDots } from "react-loader-spinner";

const LoadingIcon = ({
  height = 50,
  width = 50,
  color,
}: {
  height?: number | string;
  width?: number | string;
  color?: string;
}) => {
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <ThreeDots color={color || "green"} height={height} width={width} />
    </div>
  );
};

export default LoadingIcon;
